export const SIGNED_OUT = 'Signed Out'
